import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AppDispatch, RootState } from "src/redux/store";

import NotAuthorizedPage from "src/components/UI/NotAuthorized/NotAuthorizedPage";
import ATMPagination from "src/components/UI/atoms/ATMPagination/ATMPagination";
import ATMTable, {
  columnTypes,
} from "src/components/UI/atoms/ATMTable/ATMTable";
import ATMTableHeader from "src/components/UI/atoms/ATMTableHeader/ATMTableHeader";
import {
  setPage,
  setRowsPerPage,
  setSearchValue,
} from "src/redux/slices/TabWorkHistoryDSCAApplicationSlice";
import AuthHOC from "src/userAccess/AuthHOC";
import { AccessAction } from "src/utils/Enums/AccessAction";
import FilterCardWrapper from "../TabHistoryApplicationGumastaFilterCard/FilterCardWrapper";

type Props = {
  columns: columnTypes[];
  rows: any[];

  isTableLoading: boolean;

};

const TabWorkHistoryApplicationDSCListing = ({
  columns,
  rows,

  isTableLoading,
}: Props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const panState: any = useSelector(
    (state: RootState) => state.tabWorkHistoryDSCAApplication
  );
  const { page, rowsPerPage, totalItems, searchValue } = panState;
  return (
    <AuthHOC
      moduleName="DSC_APPLICATIONS"
      action={AccessAction.WORK_HISTORY}
      alt={<NotAuthorizedPage />}
    >
      <div className="flex flex-col gap-2 px-4  h-full  ">
     
        <div className=" border border-slate-100 flex flex-col overflow-auto rounded bg-white ">
          {/*Table Header */}
          <ATMTableHeader
            page={page}
            rowCount={totalItems}
            rowsPerPage={rowsPerPage}
            renderFilter={(close) => <FilterCardWrapper close={close} />}
            rows={rows}
            onRowsPerPageChange={(newValue) =>
              dispatch(setRowsPerPage(newValue))
            }
            searchValue={searchValue}
            onSearchChange={(newValue) => dispatch(setSearchValue(newValue))}
            isFilter
          />

          {/* Table */}
          <div className=" border flex flex-col grow overflow-auto rounded bg-white">
            <ATMTable
              disableRowClick={
                !AuthHOC({
                  type: "ACTION",
                  moduleName: "DSC_APPLICATIONS",
                  action: AccessAction.VIEW,
                  resultType: "BOOLEAN",
                })
              }
              columns={columns}
              rows={rows}
              onRowClick={(row: any) => navigate(`/dsc/${row?.digitalSignId}`)}
              isLoading={isTableLoading}
            />
          </div>

          {/* Pagination */}
          <div className="flex items-center justify-end border-t border-slate-300">
            <ATMPagination
              page={page}
              rowCount={totalItems}
              rows={rows}
              rowsPerPage={rowsPerPage}
              onPageChange={(newPage) => dispatch(setPage(newPage))}
            />
          </div>
        </div>
      </div>
    </AuthHOC>
  );
};

export default TabWorkHistoryApplicationDSCListing;
